import getDefaultDisposalType from 'mini-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import ItemContext from 'owa-mail-store/lib/store/schema/ItemContext';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Removes conversation node from tableViewConversationRelations and conversationItems in the list view store
 * @param itemContext contains the conversation id and item id of the conversation node
 * @param tableViewId is the source table view to delete from
 */
export default function removeSingleItemFromConversation(
    itemContext: ItemContext,
    tableViewId: string
) {
    const conversationItem = listViewStore.conversationItems.get(itemContext.conversationId);
    const tableConversationRelation = getTableConversationRelation(
        itemContext.conversationId,
        tableViewId
    );

    // Remove from ItemIds if found
    let removeAtIndex = tableConversationRelation.itemIds.indexOf(itemContext.itemId);
    if (removeAtIndex >= 0) {
        tableConversationRelation.itemIds.splice(removeAtIndex, 1);

        // Also update unread count
        if (!itemContext.isRead) {
            tableConversationRelation.unreadCount--;
        }
    }

    /**
     * For immutable id, temporary delete just means moving to deleted items folder, but it is still part of older conversation.
     * So we don't delete the item from conversation's global item ids.
     */
    if (
        isFeatureEnabled('fwk-immutable-ids') &&
        getDefaultDisposalType(itemContext.itemId) !== 'SoftDelete'
    ) {
        return;
    }

    // Remove from GlobalItemIds if found
    removeAtIndex = conversationItem.globalItemIds.indexOf(itemContext.itemId);
    if (removeAtIndex >= 0) {
        conversationItem.globalItemIds.splice(removeAtIndex, 1);
    }
}
